import moduleSettingsProfile from './controllers/profile';
import moduleSettingsSecurity from './controllers/security';

const ngModule = angular.module('app.holding.dashboard.settings', [
  moduleSettingsProfile,
  moduleSettingsSecurity,
]);

export default ngModule.name;

require('./directives/transfer-alias-input/transfer-alias-input');
require('./services/preferences');
require('./services/settings');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/settings/index.js